import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import classNames from "classnames";
import DateFnsUtils from "@date-io/date-fns";
import Grid from "@material-ui/core/Grid";
import Input from "@material-ui/core/Input";
import MenuItem from "@material-ui/core/MenuItem";
import PropTypes from "prop-types";
import Paper from "@material-ui/core/Paper";
import qs from "qs";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import { withStyles } from "@material-ui/core/styles";
import {
  MuiPickersUtilsProvider,
  TimePicker,
  DatePicker
} from "material-ui-pickers";

const styles = theme => ({
  container: {
    display: "flex",
    flexWrap: "wrap"
  },
  main: {
    width: "auto",
    display: "block", // Fix IE 11 issue.
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
      width: 400,
      marginLeft: "auto",
      marginRight: "auto"
    }
  },
  paper: {
    marginTop: theme.spacing.unit * 7,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme
      .spacing.unit * 3}px`
  },
  textField: {
    marginLeft: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit * 2
  },
  dense: {
    marginTop: 16
  },
  menu: {
    width: 200
  },
  grid: {
    width: "100%"
  },
  submit: {
    marginTop: theme.spacing.unit * 3,
    marginLeft: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit * 2
  }
});

class Info extends Component {
  state = {
    gender: "",
    dateofbirth: new Date()
  };

  handleDateChange = date => {
    this.setState({ dateofbirth: date });
  };

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value
    });
  };

  render() {
    const userId = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true
    }).userId;

    const { classes } = this.props;

    const { dateofbirth } = this.state;

    return (
      <main className={classes.main}>
        <CssBaseline />

        <Paper className={classes.paper}>
          <Typography component="h1" variant="h5">
            請填寫個人資料
          </Typography>
          <form method="post" className={classes.container} autoComplete="off">
            <TextField
              required
              fullWidth
              id="email"
              label="Email"
              className={classes.textField}
              type="email"
              name="email"
              margin="normal"
              variant="outlined"
            />

            <TextField
              required
              fullWidth
              id="lastname"
              label="姓"
              placeholder="王"
              name="lastname"
              className={classes.textField}
              margin="normal"
              variant="outlined"
            />

            <TextField
              required
              fullWidth
              id="firstname"
              label="名"
              placeholder="大明"
              name="firstname"
              className={classes.textField}
              margin="normal"
              variant="outlined"
            />

            <TextField
              required
              fullWidth
              id="phone"
              label="手機"
              placeholder="0912345678"
              name="phone"
              className={classes.textField}
              margin="normal"
              variant="outlined"
            />

            <TextField
              required
              fullWidth
              id="identity"
              label="身份證字號"
              name="identity"
              className={classes.textField}
              helperText="開頭字母請大寫"
              margin="normal"
              variant="outlined"
            />

            <TextField
              required
              fullWidth
              id="height"
              label="身高"
              placeholder="177.7"
              name="height"
              className={classes.textField}
              margin="normal"
              variant="outlined"
            />

            <TextField
              required
              fullWidth
              id="weight"
              label="體重"
              placeholder="77.2"
              name="weight"
              className={classes.textField}
              margin="normal"
              variant="outlined"
            />

            <TextField
              required
              fullWidth
              id="garmin_group_id"
              label="群組代碼"
              placeholder="請洽醫護人員"
              name="garmin_group_id"
              className={classes.textField}
              margin="normal"
              variant="outlined"
            />

            <TextField
              id="gender"
              select
              required
              label="性別"
              value={this.state.gender}
              onChange={this.handleChange("gender")}
              className={classes.textField}
              name="gender"
              SelectProps={{
                native: true,
                MenuProps: {
                  className: classes.menu
                }
              }}
              fullWidth
              helperText="請選擇生理性別"
              margin="normal"
              variant="outlined"
            >
              <option />
              <option key="MALE" value="MALE">
                男
              </option>
              <option key="FEMALE" value="FEMALE">
                女
              </option>
            </TextField>

            <MuiPickersUtilsProvider
              utils={DateFnsUtils}
              className={classes.textField}
            >
              <Grid container className={classes.grid} justify="space-around">
                <DatePicker
                  margin="normal"
                  label="生日"
                  style={{ width: "88%" }}
                  className={classes.textField}
                  value={dateofbirth}
                  onChange={this.handleDateChange}
                />
              </Grid>
            </MuiPickersUtilsProvider>

            <Input
              type="hidden"
              id="dateofbirth"
              name="dateofbirth"
              value={dateofbirth}
            />

            <Input
              type="hidden"
              id="userid"
              name="userid"
              value={userId}
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
            >
              送出
            </Button>
          </form>
        </Paper>
      </main>
    );
  }
}

Info.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Info);
